import React from 'react';
import { SectionWrapper } from './SectionWrapper';
export function Hook() {
  return <SectionWrapper className="bg-white" data-id="element-109">
      <div className="prose prose-lg md:prose-xl text-gray-700 mx-auto" data-id="element-110">
        <p className="leading-relaxed" data-id="element-111">
          Te despiertas, te miras al espejo y tu vientre está relativamente
          plano. Pero para las 6:00 PM, pareces tener tres meses de embarazo.
        </p>
        <p className="leading-relaxed mt-6" data-id="element-112">
          Tus pantalones te aprietan, sientes una pesadez constante y, por más
          que intentas comer menos o "matarte" en el gimnasio, ese bulto
          abdominal simplemente no se mueve.
        </p>
        <p className="leading-relaxed mt-6 font-medium text-charcoal text-xl md:text-2xl text-center italic" data-id="element-113">
          No es falta de voluntad. No es tu edad. Es un secuestro hormonal.
        </p>
      </div>
    </SectionWrapper>;
}